import { render, staticRenderFns } from "./ProductListItemImages.vue?vue&type=template&id=4b8f522c&scoped=true"
import script from "./ProductListItemImages.vue?vue&type=script&lang=js"
export * from "./ProductListItemImages.vue?vue&type=script&lang=js"
import style0 from "./ProductListItemImages.vue?vue&type=style&index=0&id=4b8f522c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f522c",
  null
  
)

export default component.exports